<template>
  <div class="loading">
    <p v-if="more && loaded" class="more">上拉显示更多数据</p>
    <p v-if="more && !loaded"><img src="./loading.gif" style="width: 15px !important; height: 15px !important;"> {{title}}</p>
    <p v-if="!more" class="more">没有更多数据</p>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    title: {
      type: String,
      default: '正在载入...'
    },
    loaded: {
      type: Boolean,
      default: false
    },
    more: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="stylus" scoped rel="stylesheet/stylus">
  @import "~common/stylus/variable"
  .loading{
    text-align center
    color: $color-text
    font-size: size(24)
    padding-top: size(10)
    padding-bottom: size(20)
    img{
      width: size(30)
      height: size(30)
      position relative
      top: size(6)
    }
    .more{
      color: #aaa
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/base/loading/loading2.vue